import { render, staticRenderFns } from "./LayoutSetting.vue?vue&type=template&id=755e4e95&"
import script from "./LayoutSetting.vue?vue&type=script&lang=ts&"
export * from "./LayoutSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports